import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import Notification from '@Components/notification';

import Utilities from '@Utils/utilities';

import isMobile from '@Utils/isMobile';

let inViewInit = true;

export const MitidSigningComponent = (props: any) => {
	const { pageFelter, dataToSend, isKnockout = false } = props;

	const [dokumentSigneringOverskrift] = useState(pageFelter.dokumentSigneringOverskrift);
	const [bilagNavn] = useState(pageFelter.bilagNavn);
	const [kvitteringsDokument] = useState(window.App.Util.decodeHtmlEntities(dataToSend.dokumentTekst));
	const [maxCount, setMaxCount] = useState(0);
	const [iframeUrl, setIframeUrl] = useState('');
	const [error, setError] = useState('');
	const { ref, inView } = useInView({ threshold: 0 });

	useEffect(() => {
		if (!isKnockout) {
			getIframeData(kvitteringsDokument);
		}
	}, []);

	const knockoutInit = () => {
		if (inView) {
			inViewInit = false;

			getIframeData(sessionStorage['dokumentTekstHtml'] || kvitteringsDokument);
		}
	};

	const appendScriptToBody = (scriptBlock: string) => {
		if (Utilities.isJqueryLoaded()) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			$(scriptBlock).appendTo($('body'));
		} else if (maxCount < 10) {
			setMaxCount(maxCount + 1);
			setTimeout(() => {
				appendScriptToBody(scriptBlock);
			}, 500);
		}
	};

	async function getIframeData(dokumentTekstHtml: string) {
		const myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		const raw = JSON.stringify({
			'KvitteringsDokument': dokumentTekstHtml,
			'DokumentSigneringOverskrift': dokumentSigneringOverskrift,
			'BilagNavn': bilagNavn,
			'aftaleReferenceNr': dataToSend?.aftaleReferenceNr
		});

		const requestOptions: any = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow'
		};

		fetch('/api/mitidsignapi/HentIframeUrl', requestOptions)
			.then(response => response.text())
			.then(result => {
				const res = JSON.parse(result);

				// error handling
				if (res.Message) {
					if (res.Message === 'Fejl i dokumentoplysninger') {
						setError(pageFelter?.errorMessages?.dokumentFejlBesked || res.Message);
					} else {
						setError(pageFelter?.errorMessages?.generelFejlBesked || res.Message || 'Der skete en fejl i MitID Signering "getIframeData" funktionen');
					}

					return;
				}

				appendScriptToBody(res.ScriptBlock);
				setIframeUrl(res.IframeUrl);

			})
			.catch(error => console.error(error));
	}

	if (inViewInit && isKnockout) {
		knockoutInit();
	}

	return (
		<div className="mitid-signing" ref={ ref }>
			{ pageFelter.headline && (
				<h1>{ pageFelter.headline }</h1>
			) }
			<div className="mitid-signing-wrapper__link">
				{ pageFelter.helplinktext && pageFelter.helplinkMobile && isMobile.any() && (
					<a href={ pageFelter.helplinkMobile } target="_blank" rel="noreferrer">{ pageFelter.helplinktext }</a>
				) }
				{ pageFelter.helplinktext && pageFelter.helplinkDesktop && !isMobile.any() && (
					<a href={ pageFelter.helplinkDesktop } target="_blank" rel="noreferrer">{ pageFelter.helplinktext }</a>
				) }
			</div>

			{ iframeUrl && (
				<iframe
					src={ iframeUrl }
					scrolling="no"
					style={ { width: '100%', height: isMobile.any() ? '1310px' : '1850px', border: 'none', margin: 0, padding: 0 } }
				/>
			) }

			{ error !== '' && (
				<Notification isError message={ error } />
			) }
		</div>
	);
};

export default MitidSigningComponent;